import { createAsyncThunk } from "@reduxjs/toolkit";
import { type ConfirmDeliveryParams } from "../../../domain/entities/pending-confirmation";
import { type PendingConfirmationDispatch } from "../../config";
import { type ExtraArgument } from "../../extra-argument";
import { type State } from "../../state";
import { thunkTypes } from "../thunk-types";

export const confirm = createAsyncThunk<
  void,
  ConfirmDeliveryParams,
  { dispatch: PendingConfirmationDispatch; extra: ExtraArgument; state: State }
>(thunkTypes.CONFIRM, async (params, { extra }) => {
  await extra.contactCenterRepo.confirm(params);
});
